import { ChangeDetectionStrategy, Component, HostBinding, OnInit, ViewEncapsulation } from "@angular/core";
import { Store } from "@ngrx/store";
import { Page, PageSelector2 } from "@obg/ngx.core";
import { RouterState, RouteSelector } from "@obg/ngx.router";
import { Observable } from "rxjs";
import { filter, switchMap, tap } from "rxjs/operators";

import { ContentConfigService } from "./content.config";
import { ContentPageParams } from "./content.model";

@Component({
	selector: "obg-content-container",
	templateUrl: "./content.container.html",
	styleUrls: ["./content.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class ContentContainer implements OnInit {
	@HostBinding("class.obg-content") class = true;

	routeData: ContentPageParams | undefined;
	data$: Observable<Page | undefined> | undefined;
	isAnchorsMenuEnabled = this.configService.isAnchorsMenuEnabled();

	constructor(
		private store: Store<RouterState>,
		private configService: ContentConfigService
	) {}

	ngOnInit() {
		this.data$ = this.store.select<ContentPageParams | undefined>(RouteSelector.getData).pipe(
			filter((routeData) => !!routeData && !!routeData.document),
			tap((routeData) => {
				this.routeData = routeData!;
				if (routeData?.hideAnchors) {
					this.isAnchorsMenuEnabled = false;
				}
			}),
			switchMap((routeData) => this.store.select(PageSelector2.get(routeData!.document)))
		);
	}
}
